import { useMemo } from "react";
import useWishlist from "@vercel/commerce/wishlist/use-wishlist";
import ensureIToken from "../utils/tokens/ensure-itoken";
import normalizeWishlist from "../utils/normalizations/normalize-wishlist";
import isLoggedIn from "../utils/tokens/is-logged-in";
import createEmptyWishlist from "../utils/create-empty-wishlist";
import { getWishlistToken, removeWishlistToken, setWishlistToken } from "../utils/tokens/wishlist-token";
import axios from "axios";
import { requireConfigValue } from "../isomorphic-config";
const defaultImagesSize = requireConfigValue("imagesSize");
const defaultImagesQuality = requireConfigValue("imagesQuality");
export default useWishlist;
export const handler = {
    // Provide fetchOptions for SWR cache key
    fetchOptions: {
        url: "wishlists",
        query: "default"
    },
    async fetcher ({ input , options , fetch  }) {
        //Uncomment the following line to debug
        /*     console.info(
      'useWishlist fetcher called. Configuration: ',
      'input: ',
      input,
      'options: ',
      options
    ) */ let spreeWishlistResponse = null;
        const params = {
            include: [
                "wished_items",
                "wished_items.variant",
                "wished_items.variant.product",
                "wished_items.variant.product.primary_variant",
                "wished_items.variant.product.images",
                "wished_items.variant.product.option_types",
                "wished_items.variant.product.variants",
                "wished_items.variant.product.variants.option_values",
                "wished_items.diamond", 
            ].join(","),
            image_transformation: {
                quality: defaultImagesQuality,
                size: "600x600" || defaultImagesSize
            }
        };
        // Check if it's a guest user.
        if (!isLoggedIn()) {
            const wishlistToken = getWishlistToken();
            // If the wishlist guest token is already stored in cookies, fetch the guest wishlist.
            if (wishlistToken) {
                const options1 = {
                    method: "GET",
                    url: `${process.env.storefrontApiUrl}/wishlists/${wishlistToken}`,
                    params: params,
                    headers: {
                        Accept: "application/vnd.api+json"
                    }
                };
                try {
                    const { data: spreeWishlistsShowSuccessResponse  } = await axios.request(options1);
                    spreeWishlistResponse = spreeWishlistsShowSuccessResponse;
                } catch (error) {
                    // In case of error, remove the token so that a new wishlist is generated
                    removeWishlistToken();
                    spreeWishlistResponse = null;
                }
            // If the wishlist guest token is not stored, then create a new guest wishlist.
            } else {
                const { data: spreeWishlistCreateSuccessResponse  } = await createEmptyWishlist(fetch);
                spreeWishlistResponse = spreeWishlistCreateSuccessResponse;
                // Save the new guest wishlist token
                setWishlistToken(spreeWishlistResponse.data.attributes.token);
            }
        // If the user is logged in then fetch the default wishlist
        } else {
            // TODO: Optimize with includeProducts.
            const token = ensureIToken();
            const { data: spreeWishlistsDefaultSuccessResponse  } = await fetch({
                variables: {
                    methodPath: "wishlists.default",
                    arguments: [
                        token,
                        params
                    ]
                }
            });
            spreeWishlistResponse = spreeWishlistsDefaultSuccessResponse;
        }
        if (spreeWishlistResponse) {
            const normalizedWishlist = normalizeWishlist(spreeWishlistResponse, spreeWishlistResponse.data);
            // Call mutate to update the cache with the new data
            // mutate('wishlists', normalizedWishlist, false).catch((error) => {
            //   console.error('Error updating cache:', error)
            // })
            return normalizedWishlist;
        } else {
            // In case of error, remove the token so that a new wishlist is generated
            removeWishlistToken();
            return null;
        }
    },
    useHook: ({ useData  })=>{
        const useWrappedHook = (input)=>{
            const response = useData({
                swrOptions: {
                    revalidateOnFocus: false,
                    ...input == null ? void 0 : input.swrOptions
                }
            });
            return useMemo(()=>{
                return Object.create(response, {
                    isEmpty: {
                        get () {
                            var ref, ref1;
                            return (((ref = response.data) == null ? void 0 : (ref1 = ref.items) == null ? void 0 : ref1.length) || 0) <= 0;
                        },
                        enumerable: true
                    }
                });
            }, [
                response
            ]);
        };
        return useWrappedHook;
    }
};
